<template>
  <v-autocomplete
    v-model="oktaGroup"
    v-bind="$attrs"
    :items="getGroupList"
    :rules="required"
    name="selectedOktaGroup"
    label="Select Okta Group"
    class="required"
    item-text="value"
    item-value="id"
    return-object
    @change="$emit('change', $event)"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import find from 'lodash/find'

export default {
  name: 'okta-group-select',
  props: {
    selectedId: Number,
    selectedName: String
  },
  data() {
    return {
      oktaGroup: null,
      required: [
        v => !!v || 'Required'
      ]
    }
  },
  computed: {
    ...mapGetters('oktaGroups', ['getGroupList'])
  },
  created() {
    if (this.selectedId) this.oktaGroup = find(this.getGroupList, { id: this.selectedId })
    if (this.selectedName) this.oktaGroup = find(this.getGroupList, { value: this.selectedName })
  }
}
</script>
